import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=989f0b08&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=js&"
export * from "./Money.vue?vue&type=script&lang=js&"
import style0 from "./Money.vue?vue&type=style&index=0&id=989f0b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989f0b08",
  null
  
)

export default component.exports